export const getBase64Image = (imageStr: string) => `data:image/png;base64,${imageStr}`;
